/**
 * Created by asiulik on 15.05.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../map/map', './finderConst'], function($, _, EventEmitter, Map, FinderConst){

    function FinderMap($finderContainer, mapSelector, mapConfig){
        this.$finderContainer = $finderContainer;
        this.finderMapSelector = mapSelector || FinderConst.finderMapSelector;
        this.mapConfig = mapConfig || {};
    }

    FinderMap.prototype = _.clone(EventEmitter.prototype);

    FinderMap.prototype.init = function() {

        var _this = this;

        this.mapElement = this.$finderContainer.get(0).querySelector(this.finderMapSelector);

        this.map = new Map(this.mapElement, this.mapConfig);

        this.map.on('map.inited', function () {
            _this.emit('finder.map.inited');
        });
        this.map.init();
    };

    FinderMap.prototype.resizeMap = function(){
        google.maps.event.trigger(this.map.getMap(), "resize");
    };

    FinderMap.prototype.getMap = function(){
        return this.map.getMap();
    };

    FinderMap.prototype.centerMapByMarkersPosition = function(markersCollection) {

        var bounds = new google.maps.LatLngBounds();

        [].forEach.call(markersCollection, function(marker) {
            bounds.extend(marker.getPosition());
        });

        this.getMap().fitBounds(bounds);

        return bounds;

    };

    FinderMap.prototype.checkMaxZoomIsCorrect = function(){

        var _this = this;

        setTimeout(function(){
            if(_this.map.mapInstace.getZoom() > 15){
                _this.map.mapInstace.setZoom(15)
            }
        }, 100)

    };

    FinderMap.prototype.panTo = function(position){
        this.map.getMap().setCenter(position);
    };

    return FinderMap;

});


// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finderMap.js